/* eslint-disable */
import AgeModel from "../Entity/AgeModel";
import {propsDecorator} from "@/js/common/Domain/Service/mixins/decorators";
@propsDecorator({
	model: AgeModel
})

export default class AgesCollection extends Backbone.Collection{

}